var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jjt-label-content"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"content",style:({ marginTop: _vm.gap + 'px' })},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }